// state
const state = () => ({
  centralUser: [],
  refreshStore: false,
  });
  
  // getters
  const getters = {};
  
  // actions
  const actions = {
    getUser({ commit }, payload) {
      commit('getUser', payload);
    },
    refreshStore({ commit }, fields) {
      commit('refreshStore', fields);
    },
  };
  
  // mutations
  const mutations = {
    getUser(state, data) {
      state.centralUser = data;
    },
    refreshStore(state, data) {
      state.refreshStore = !state.refreshStore;
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };


// WEBPACK FOOTER //
// ./src/store/modules/central.js